var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 18.6C0.125 18.35 0 18.0542 0 17.7125C0 17.3708 0.125 17.075 0.375 16.825L7.7 9.5L0.35 2.15C0.116667 1.91667 0 1.625 0 1.275C0 0.925 0.125 0.625 0.375 0.375C0.625 0.125 0.920833 0 1.2625 0C1.60417 0 1.9 0.125 2.15 0.375L10.55 8.8C10.65 8.9 10.7208 9.00833 10.7625 9.125C10.8042 9.24167 10.825 9.36667 10.825 9.5C10.825 9.63333 10.8042 9.75833 10.7625 9.875C10.7208 9.99167 10.65 10.1 10.55 10.2L2.125 18.625C1.89167 18.8583 1.60417 18.975 1.2625 18.975C0.920833 18.975 0.625 18.85 0.375 18.6Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6fb0fe649bcd827f0d16b4f20db3a98b.svg";
export { ForwardRef as ReactComponent };